module.exports = __webpack_public_path__ + "static/img/pddbg1.9c142e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/pddbg1.png
// module id = 1255
// module chunks = 0